import { render, staticRenderFns } from "./KeyResultUpdates.vue?vue&type=template&id=79879f6e&"
import script from "./KeyResultUpdates.vue?vue&type=script&lang=js&"
export * from "./KeyResultUpdates.vue?vue&type=script&lang=js&"
import style0 from "./KeyResultUpdates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports